/* eslint-disable camelcase */
import { Language, LanguageType } from '@nx-smartmonkey/shared/domain';
import { UserBase } from '../../domain/backoffice/user/UserBase';
import { UserBaseDTO } from '../../domain/backoffice/user/UserBaseDTO';

class UserBaseMapper {
  static toDomain(props: UserBaseDTO): UserBase {
    const {
      id,
      avatar_url,
      organization_id,
      default_project_id,
      email,
      first_name,
      last_name,
      phone,
      active,
      roles,
      language,
      validation,
      created_at,
      notifications,
      public_key,
      private_key,
      deleted,
    } = props;

    const languageDomain = Language.create(language as LanguageType);

    return UserBase.create(
      {
        avatar_url,
        organization_id,
        default_project_id,
        email,
        first_name,
        last_name,
        phone,
        active,
        roles,
        language: languageDomain,
        validation,
        created_at,
        notifications,
        public_key,
        private_key,
        deleted,
      },
      id
    );
  }
}

export default UserBaseMapper;
